import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import classNames from "classnames";

import { SelectList } from "@common/selectList";
import { StatusFilters } from "../../types";
import { ArrowIcon } from "./arrowIcon";
import { Props } from "./types";
import styles from "./styles.scss";

function StatusFilter({ statuses, setStatuses }: Props) {
  const { t } = useTranslation();
  const addFilter = (status: StatusFilters) =>
    setStatuses(
      !statuses.includes(status)
        ? [...statuses, status]
        : statuses.filter((s) => status !== s),
    );
  const addAllFilter = () =>
    setStatuses([
      StatusFilters.FINISHED,
      StatusFilters.STARTED,
      StatusFilters.PLANNED,
    ]);

  return (
    <div className={styles.statusFilter}>
      <div className={styles.title}>{t("kanban.filters.statuses.title")}</div>
      <SelectList
        rootClassName={styles.rootClassName}
        listClassName={styles.listRoot}
      >
        {({ isOpen, select }) => ({
          input: (
            <div
              className={classNames(styles.input, {
                [styles.openedInput]: isOpen,
              })}
            >
              <p className={styles.selectedStatuses}>
                {statuses.length === 3
                  ? t("kanban.filters.statuses.all")
                  : statuses.length > 0
                    ? statuses.map((elem) => t(elem)).join(", ")
                    : "---"}
              </p>
              <ArrowIcon
                className={classNames(styles.icon, {
                  [styles.iconOpen]: isOpen,
                })}
              />
            </div>
          ),
          list: (
            <div className={styles.list}>
              <div
                onClick={addAllFilter}
                className={classNames(styles.selectAll, {
                  [styles.selected]: statuses.length === 3,
                })}
              >
                {t("kanban.filters.statuses.all")}
              </div>
              <div
                className={styles.item}
                onClick={() => addFilter(StatusFilters.FINISHED)}
              >
                <div
                  className={classNames(styles.checkbox, {
                    [styles.checked]: statuses.includes(StatusFilters.FINISHED),
                  })}
                />
                {t("kanban.filters.statuses.done")}
              </div>
              <div
                className={styles.item}
                onClick={() => addFilter(StatusFilters.STARTED)}
              >
                <div
                  className={classNames(styles.checkbox, {
                    [styles.checked]: statuses.includes(StatusFilters.STARTED),
                  })}
                />
                {t("kanban.filters.statuses.started")}
              </div>
              <div
                className={styles.item}
                onClick={() => addFilter(StatusFilters.PLANNED)}
              >
                <div
                  className={classNames(styles.checkbox, {
                    [styles.checked]: statuses.includes(StatusFilters.PLANNED),
                  })}
                />
                {t("kanban.filters.statuses.planned")}
              </div>
            </div>
          ),
        })}
      </SelectList>
    </div>
  );
}

export { StatusFilter };
